import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=53169fcc&scoped=true"
import script from "./prize.vue?vue&type=script&lang=js"
export * from "./prize.vue?vue&type=script&lang=js"
import style0 from "./prize.vue?vue&type=style&index=0&id=53169fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53169fcc",
  null
  
)

export default component.exports